var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlastering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.82,26.94c-1.58,1.96-3.48,4.22-3.48,6.53c0,1.28,0.18,1.32,1.06,7.62c0.46,3.27-2.1,6.2-5.4,6.2 c-3.1,0-5.82-2.63-5.4-6.2l0.95-7.62c0.39-2.86-1.41-4.09-3.36-6.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,47.78c-1.7,0-3.33-0.73-4.45-2c-1.14-1.28-1.65-2.98-1.44-4.77l0.95-7.62c0.28-2.07-0.67-3.16-2.12-4.8 c-0.36-0.41-0.75-0.85-1.14-1.34c-0.17-0.22-0.14-0.53,0.08-0.71c0.22-0.17,0.53-0.14,0.71,0.08c0.38,0.47,0.76,0.9,1.11,1.3 c1.45,1.65,2.7,3.08,2.36,5.59l-0.95,7.61c-0.18,1.5,0.25,2.91,1.2,3.98c0.94,1.05,2.29,1.66,3.7,1.66 c1.43,0,2.79-0.62,3.74-1.71c0.94-1.08,1.36-2.51,1.17-3.92c-0.4-2.9-0.66-4.47-0.81-5.44c-0.19-1.16-0.25-1.51-0.25-2.24 c0-2.39,1.81-4.64,3.4-6.62l0.18-0.23c0.17-0.22,0.49-0.25,0.71-0.08c0.22,0.17,0.25,0.49,0.08,0.71l-0.18,0.23 c-1.49,1.85-3.18,3.95-3.18,5.99c0,0.65,0.05,0.95,0.23,2.08c0.16,0.98,0.42,2.56,0.82,5.47c0.24,1.7-0.27,3.42-1.4,4.72 C28.36,47.04,26.72,47.78,25,47.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.2,41.8c0,1.22-0.98,2.2-2.2,2.2c-1.21,0-2.19-0.98-2.19-2.2c0-1.22,0.98-2.2,2.19-2.2 C26.22,39.6,27.2,40.58,27.2,41.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,44.5c-1.49,0-2.7-1.21-2.7-2.7c0-1.49,1.21-2.71,2.7-2.71c1.49,0,2.71,1.21,2.71,2.71 C27.7,43.29,26.49,44.5,25,44.5z M25,40.1c-0.93,0-1.69,0.76-1.69,1.7c0,0.94,0.76,1.7,1.69,1.7c0.94,0,1.7-0.76,1.7-1.7 C26.7,40.86,25.94,40.1,25,40.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "49.5,2.72 47.29,20.78 2.71,20.78 0.5,2.72  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.71,21.28c-0.25,0-0.47-0.19-0.5-0.44L0,2.78c-0.02-0.14,0.03-0.29,0.12-0.39c0.1-0.11,0.23-0.17,0.38-0.17 h49c0.14,0,0.28,0.06,0.38,0.17c0.1,0.11,0.14,0.25,0.12,0.39l-2.2,18.06c-0.03,0.25-0.24,0.44-0.5,0.44L2.71,21.28z M1.07,3.22 l2.09,17.06l43.69,0l2.08-17.06H1.07z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.08,10.45v-0.13c-2.93,0-2.93,2.35-5.87,2.35c-2.93,0-2.93-2.35-5.87-2.35c-2.93,0-2.93,2.35-5.88,2.35 c-2.92,0-2.92-2.35-5.86-2.35c-2.93,0-2.93,2.35-5.87,2.35c-2.93,0-2.93-2.35-5.86-2.35c-2.93,0-2.93,2.35-5.87,2.35 c-2.93,0-2.93-2.35-5.87-2.35v0.13L0.18,2.48l48.88,0L48.08,10.45z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "49.1,20.78 47.82,26.8 2.19,26.8 0.91,20.78  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.19,27.3c-0.24,0-0.44-0.17-0.49-0.4l-1.28-6.02c-0.03-0.15,0.01-0.3,0.1-0.42s0.24-0.19,0.39-0.19H49.1 c0.15,0,0.29,0.07,0.39,0.19s0.13,0.27,0.1,0.42l-1.28,6.02c-0.05,0.23-0.25,0.4-0.49,0.4L2.19,27.3z M1.53,21.28L2.6,26.3 l44.82,0l1.07-5.02H1.53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1.39,24.29 1.92,26.3 48.09,26.3 48.62,24.29  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlastering);
export default __webpack_public_path__ + "static/media/plastering.1b779295927ec2436c40fea7971cc7a6.svg";
export { ForwardRef as ReactComponent };